export const CompanyBillCreate = () => import("./CompanyBillCreate.vue");
export const Create = () => import("./Create.vue");
export const View = () => import("./View.vue");
